export default __webpack_public_path__ + "static/header-ensino-fundamental-ii-a9ff5780404f1a531320617ddeb82799.png";